import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstadoRouteService {
  public contadorHistorial: number = 0;
  private historialNavegacion: string[] = [];
  public agregarHistorial: boolean = true;
  public mostrarBtnAvanzar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public mostrarBtnRetroceder$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public mostrarBtnRegresarDetalleObra$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public detalleObraProceso$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public mostrarBtnCatalogos$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public catalogos$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public historialAvance: string[] = [];

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe((e: any) => {
      if (this.agregarHistorial) {
        this.historialNavegacion.push(e.url);
        this.contadorHistorial = this.historialNavegacion.length;
        this.mostrarBtnRetroceder$.next(true);
      }
      this.agregarHistorial = true;
    });
  }

  get rutaAnterior() {
    return this.historialNavegacion[this.historialNavegacion.length - 2];
  }

  public async retroceder() {
    this.agregarHistorial = false;
    await this.router.navigate([this.historialNavegacion[this.contadorHistorial - 2]], { skipLocationChange: true });
    this.historialAvance.push(this.historialNavegacion.pop());
    this.contadorHistorial -= 1;
    if (this.contadorHistorial - 2 <= 0) {
      this.mostrarBtnRetroceder$.next(false);
    }
    // else {
    //   this.mostrarBtnRetroceder$.next(true);
    // }
  }




  public async avanzar() {
    await this.router.navigate([this.historialAvance.length - 1], { skipLocationChange: true });
  }

}
